import {CreateActiveAction} from "../../Traits/ActiveItem";
import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Orders
 * @type {function(type: string): {type: string, payload: any}}
 */
export const ordersGetRequest = simpleAction(TYPES.ORDERS_GET_REQUEST);

/**
 * Request orders success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const ordersGetSuccess = simpleAction(TYPES.ORDERS_GET_SUCCESS);

/**
 * Request orders error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const ordersGetError = simpleAction(TYPES.ORDERS_GET_FAIL);

/**
 * Request Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderLoadRequest = simpleAction(TYPES.ORDER_LOAD_REQUEST);

/**
 * Request Order success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderLoadSuccess = simpleAction(TYPES.ORDER_LOAD_SUCCESS);

/**
 * Request Order error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderLoadError = simpleAction(TYPES.ORDER_LOAD_FAIL);

/**
 * Create Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderCreateRequest = simpleAction(TYPES.ORDER_CREATE_REQUEST);

/**
 * Create Order Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderCreateSuccess = simpleAction(TYPES.ORDER_CREATE_SUCCESS);

/**
 * Create Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderCreateError = simpleAction(TYPES.ORDER_CREATE_FAIL);

/**
 * Create Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderCreateDone = simpleAction(TYPES.ORDER_CREATE_DONE);

/**
 * Update Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderUpdateRequest = simpleAction(TYPES.ORDER_UPDATE_REQUEST);

/**
 * Update Order Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderUpdateSuccess = simpleAction(TYPES.ORDER_UPDATE_SUCCESS);

/**
 * Update Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderUpdateError = simpleAction(TYPES.ORDER_UPDATE_FAIL);

/**
 * Update Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const orderUpdateDone = simpleAction(TYPES.ORDER_UPDATE_DONE);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}
 */
export const orderActiveRequest = simpleAction(TYPES.ACTIVE_REQUEST);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}}
 */
export const orderActiveClean = simpleAction(TYPES.ACTIVE_CLEAN);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}}
 */
export const orderActiveSuccess = simpleAction(TYPES.ACTIVE_SUCCESS);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}}
 */
export const orderActiveError = simpleAction(TYPES.ACTIVE_FAIL);

/**
 * Create a function to get active order
 */
export const getActiveOrder = CreateActiveAction("Orders", {
    itemProperty: "activeItem",
    dispatchMethod: "orderActiveRequest",
    stateProperty: "order",
    propsProperty: "order",
    routeParam: "order",
});
